module.exports = {
      id: "tamilnadu-usage",
      viewBox: "0 0 857.199 1020.664",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#tamilnadu",
      toString: function () {
        return this.url;
      }
    }